module.exports = new __parcel__URL__("linkedin.b0d336c3.svg").toString();